// @flow
import React, { Component } from 'react';
import moment from 'moment';
import Radio from 'common/domain/radio';
import AgeRangeReaches from 'common/domain/AgeRangeReaches';
import GenderReach from 'common/domain/GenderReach';
import PrintingService from 'common/services/PrintingService';
import PrintingPage from 'common/components/PrintingPage';
import AntennaReach from 'statsradio/domain/AntennaReach';
import type { GeoMapTypes } from 'statsradio/modules/dashboard/domain/DashboardData';
import SalesFlyerPrinting from './components/printing/SalesFlyerPrinting';
import type { SalesFlyer } from './domain/sales';
import GeolocationReach from '../dashboard/domain/GeolocationReach';
import { CentralMarket } from '../centralMarkets/domain/CentralMarket';

type State = {
  loaded: boolean;
  flyer: ?SalesFlyer;
  radio: ?Radio;
  geoMapType: GeoMapTypes,
  geoMapData: Object,
  centralMarket: ?CentralMarket;
}

export default class SalesFlyerPrintingPage extends Component<void, State> {
  state = {
    loaded: false,
    flyer: undefined,
    radio: undefined,
    geoMapType: undefined,
    geoMapData: {},
    centralMarket: undefined,
  };

  componentWillMount() {
    const data = PrintingService.getData('SALES_FLYER_DATA');
    if (!data) {
      return;
    }

    const flyer = data.flyer && {
      ...data.flyer,
      from: moment(data.flyer.from),
      to: moment(data.flyer.to),
      ages: AgeRangeReaches.parse(data.flyer.ages),
      genders: GenderReach.parse(data.flyer.genders),
      antennaReach: data.flyer.antennaReach ? AntennaReach.parse(data.flyer.antennaReach) : undefined,
      reachByRegion: data.flyer.reachByRegion ? data.flyer.reachByRegion.map(geolocation => GeolocationReach.parse(geolocation)) : undefined,
    };

    this.setState({
      loaded: true,
      flyer: flyer,
      radio: data.radio,
      centralMarket: data.centralMarket && CentralMarket.parse(data.centralMarket),
      geoMapType: data.geoMapType,
      geoMapData: {
        antennas: data.antennas,
        layout: data.layout,
        antennaMapViewport: data.antennaMapViewport,
      },
    }, () => {
      setTimeout(() => window.print(), 1000);
    });
  }

  render() {
    const {
      loaded,
      flyer,
      radio,
      geoMapType,
      geoMapData,
      centralMarket,
    } = this.state;

    return (
      <PrintingPage loading={!loaded}>
        {radio && flyer && (
          <SalesFlyerPrinting
            flyer={flyer}
            radio={radio}
            geoMapType={geoMapType}
            geoMapData={geoMapData}
            centralMarket={centralMarket}
          />
        )}
      </PrintingPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/SalesFlyerPrintingPage.js